import { useEffect } from 'react';
import { pageVisitApi } from '../api';

// 동일 페이지 재기록 방지 시간 - 새로고침/짧은 재방문 중복 차단
const DEDUP_WINDOW_MS = 30 * 60 * 1000;

function getSessionId(): string {
  let sid = sessionStorage.getItem('woosu_sid');
  if (!sid) {
    sid = `${Date.now()}_${Math.random().toString(36).substring(2, 10)}`;
    sessionStorage.setItem('woosu_sid', sid);
  }
  return sid;
}

export function usePageTracker(pagePath: string, pageTitle?: string) {
  useEffect(() => {
    // 동일 세션(브라우저 탭)에서 같은 페이지는 30분 내 한 번만 기록.
    // sessionStorage는 새로고침에도 유지되므로 새로고침 중복이 차단된다.
    const key = `woosu_tracked_${pagePath}`;
    const last = Number(sessionStorage.getItem(key) || 0);
    const now = Date.now();
    if (last && now - last < DEDUP_WINDOW_MS) return;
    sessionStorage.setItem(key, String(now));

    pageVisitApi.track({
      page_path: pagePath,
      page_title: pageTitle,
      referrer: document.referrer || undefined,
      session_id: getSessionId(),
    });
  }, [pagePath, pageTitle]);
}
